import _ from 'lodash';
import { configSquareType } from "@/config/squareType";

/**
 Sort by parent id (pid) before set
 From [{pid: null, id: 1}, {pid: null, id: 2 }, {pid: 1, id: 3}, {pid: 1, id: 4}, {pid: 2, id: 5}]
 To [{
      parent: {pid: null, id: 1},
      children: [{pid: 1, id: 3}, {pid: 1, id: 4}]
    },
 {
      parent: {pid: null, id: 2},
      children: [{pid: 2, id: 5}]
    }]
 */
export const groupItems = (data) => {
  let items = _.cloneDeep(data);
  return items.map((item) => {
    // Get parent in the array
    // [{ parent: {...}, child: [] }]
    let group = item.images.reduce((prevData, currObj) => {
      if (!currObj.pid) {
        let order = 0;
        if (item.boxes && currObj.template_box_id) {
          order = item.boxes.find((box) => box.id === currObj.template_box_id)?.order
        }
        prevData[currObj.id] = {
          parent: currObj,
          children: [],
          order: order ? order : 0
        };
      }
      return prevData;
    }, {});

    // Put children to parent group
    // [{ parent: {...}, child: [{...}, {...}] }]
    item.images.forEach(imgItem => {
      if (imgItem.pid && group[imgItem.pid]) {
        group[imgItem.pid].children.push(imgItem);
      }
    });
    item.group = group;
    return item;
  });
}

/**
 Sort by parent id (pid) before set
 From [{pid: null, id: 1}, {pid: null, id: 2 }, {pid: 1, id: 3}, {pid: 1, id: 4}, {pid: 2, id: 5}]
 To [{pid: null, id: 1}, {pid: null, id: 2 }, {pid: 1, id: 3}, {pid: 2, id: 5}, {pid: 1, id: 4}]
 */
export const sortItems = (data) => {
  let items = _.cloneDeep(data);
  return items.map((item) => {
    // Get parent in the array
    // [{ parent: {...}, child: [] }]
    let group = item.images.reduce((prevData, currObj) => {
      if (!currObj.pid) {
        prevData[currObj.id] = {
          parent: currObj,
          children: []
        };
      }
      return prevData;
    }, {});

    // Put children to parent group
    // [{ parent: {...}, child: [{...}, {...}] }]
    item.images.forEach(imgItem => {
      if (imgItem.pid && group[imgItem.pid]) {
        group[imgItem.pid].children.push(imgItem);
      }
    });
    item.images = [];
    for (let i in group) {
      item.images = item.images.concat([
        group[i].parent,
        ...group[i].children
      ])
    }

    return item;
  });
}

export const getTitle = (item, template) => {
  if (item.title) return item.title;
  if (!template?.boxes) return '';
  let box = template.boxes.find(({ id }) => item.template_box_id === id);
  if (box) return box.title;
  return '';
}

export const getTitleTemplate = (item, template) => {
  // if (item.title) return item.title;
  if (!template?.boxes) return '';
  let box = template.boxes.find(({ id }) => item.template_box_id === id);
  if (box) return box.order + "_" + box.title;
  return '';
}

export const getTitleBusiness = (item, template) => {
  if (item.title) return item.title.replace(/[0-9]/g, '');
  if (!template?.boxes) return '';
  let box = template.boxes.find(({ id }) => item.template_box_id === id);
  if (box) return box.title.replace(/[0-9]/g, '');
  return '';
}

export const groupItemBusiness = (data) => {
  let items = _.cloneDeep(data);
  return items.map((item) => {
    // Get parent in the array
    let group = item.images.reduce((prevData, currObj) => {
      if (!currObj.pid) {
        prevData[currObj.id] = {
          parent: currObj,
          children: [currObj]
        };
      }
      return prevData;
    }, {});

    // Put children to parent group
    item.images.forEach(imgItem => {
      if (imgItem.pid && group[imgItem.pid]) {
        group[imgItem.pid].children.push(imgItem);
      }
    });
    item.group = group;
    return item;
  });
}

export const groupItemsBatch = (data, index, boxes) => {
  let box = boxes.find(({ id, box_type }) => data[index].parent.template_box_id === id && [configSquareType.checked, configSquareType.rounded].includes(box_type));
  let title = box?.title;
  if (title) {
    for (let i in data) {
      if (i !== index ) {
        let boxCheck = boxes.find(({ id, box_type }) => data[i].parent.template_box_id === id &&
            [configSquareType.checked, configSquareType.rounded].includes(box_type));
        if (boxCheck) {
          let titleCheck = boxCheck.title;
          if (titleCheck === title) {
            if (!data[index].children.length) {
              data[index].children.push({ result: data[index].parent.result})
            }
            data[index].children.push({ result: data[i].parent.result})
            delete data[i]
          }
        }
      }
    }
  }
}
